import React, { useState, useEffect } from 'react';

const TypingTitle = () => {
  const [displayText, setDisplayText] = useState('');
  const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  
  const titles = [
    "Full Stack Developer",
    "Machine Learning Engineer"
  ];
 
  useEffect(() => {
    const currentTitle = titles[currentTitleIndex];
    const updateText = () => {
      if (!isDeleting) {
        if (displayText.length < currentTitle.length) {
          setDisplayText(currentTitle.slice(0, displayText.length + 1));
          return 100; // Typing speed
        } else {
          setIsDeleting(true);
          return 2000; // Pause before deleting
        }
      } else {
        if (displayText.length === 0) {
          setIsDeleting(false);
          setCurrentTitleIndex((prev) => (prev + 1) % titles.length);
          return 500; // Pause before typing next title
        }
        setDisplayText(currentTitle.slice(0, displayText.length - 1));
        return 50; // Deleting speed
      }
    };

    const timeout = setTimeout(() => {
      const nextDelay = updateText();
      clearTimeout(timeout);
      setTimeout(updateText, nextDelay);
    }, 100);

    return () => clearTimeout(timeout);
  }, [displayText, currentTitleIndex, isDeleting]);

  return (
    <div className="profile-text">
      <h1>About Me</h1>
      <h2>Rahul Mishra</h2>
      <h3 className="typing-title">
        <span className="typed-text">{displayText}</span>
        <span className="cursor">|</span>
      </h3>
    </div>
  );
};

export default TypingTitle;
